import { NgModule } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonDefaultProvider, CommonProvider } from './common.provider';
import { Logger } from '@uploadcam/common';
import * as Sentry from '@sentry/angular';
import { FirebaseToken } from '../../app/core/firebase.module';
import { Functions } from 'firebase/functions';
import { TriggerFunctionInteractor } from './domain/interactors/trigger-function.interactor';
import { GoogleIdentityService } from './google/google-identity.service';
import { GoogleApiService } from './google/google-api.service';

@NgModule({
  providers: [
    {
      provide: CommonProvider,
      deps: [FirebaseToken.Functions],
      useFactory: (functions: Functions) =>
        new CommonDefaultProvider(
          environment.flavor,
          functions,
          environment.google.apiKey,
          Sentry,
          environment.sentry?.dsn,
        ),
    },
    {
      provide: Logger,
      deps: [CommonProvider],
      useFactory: (common: CommonProvider) => common.provideLogger(),
    },
    {
      provide: TriggerFunctionInteractor,
      deps: [CommonProvider],
      useFactory: (common: CommonProvider) => common.provideTriggerFunction(),
    },
    {
      provide: GoogleApiService,
      deps: [CommonProvider],
      useFactory: (common: CommonProvider) => common.provideGoogleApiService(),
    },
    {
      provide: GoogleIdentityService,
      deps: [CommonProvider],
      useFactory: (common: CommonProvider) => common.provideGoogleIdentityService(),
    },
  ],
})
export class CommonProviderModule {}
